/* eslint-disable */
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import CrmLeadInformationCommonHeader from "../common/CrmLeadInformationCommonHeader";
import { assetImages } from "constants";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";

// Timeline Item Component
const TimelineItem = ({ event, t, index, selectedIds, toggleSelection, getModuleName }) => {
  const getEventIcon = (action) => {
    const icons = {
      created: "person_add",
      updated: "edit",
      deleted: "delete",
      note_added: "note_add",
      note_updated: "edit_note",
      note_deleted: "note",
      email_sent: "mail",
      email_received: "mark_email_read",
      message_sent: "chat",
      task_created: "task_alt",
      task_updated: "edit",
      task_completed: "check_circle",
      task_assigned: "assignment_ind",
      tag_added: "label",
      tag_removed: "label_off",
      file_uploaded: "upload_file",
      survey_sent: "assignment",
      survey_responded: "assignment_turned_in",
      call_logged: "phone",
      meeting_scheduled: "calendar_month",
      status_changed: "swap_horiz",
      invoice_created: "receipt",
      invoice_paid: "payments",
      payment_made: "payments",
      opportunity_created: "trending_up",
      opportunity_updated: "analytics",
      registered: "how_to_reg",
      logged_in: "login",
    };
    return icons[action] || "event";
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInMs = now - date;
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const diffInWeeks = Math.floor(diffInDays / 7);
    const diffInMonths = Math.floor(diffInDays / 30);

    if (diffInHours < 1) return t("Just now");
    if (diffInHours < 24) return `${diffInHours} ${t("hours ago")}`;
    if (diffInDays === 1) return t("Yesterday");
    if (diffInDays < 7) return `${diffInDays} ${t("days ago")}`;
    if (diffInWeeks === 1) return t("1 week ago");
    if (diffInWeeks < 4) return `${diffInWeeks} ${t("weeks ago")}`;
    if (diffInMonths === 1) return t("1 month ago");
    if (diffInMonths < 12) return `${diffInMonths} ${t("months ago")}`;
    return date.toLocaleDateString();
  };

  const formatDateTimeDMY = (dateString) => {
    const d = new Date(dateString);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    let hours = d.getHours();
    const minutes = d.getMinutes().toString().padStart(2, "0");
    const seconds = d.getSeconds().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  return (
    <div
      className="timeline-item d-flex gap-2 mb-2"
      style={{ animation: `fadeInUp 0.3s ease-out ${index * 0.05}s both` }}
    >
      <div className="timeline-icon-wrapper position-relative">
        <div
          className="timeline-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center shadow-sm"
          style={{ width: "32px", height: "32px", minWidth: "32px", transition: "all 0.2s ease" }}
        >
          <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>
            {getEventIcon(event.action)}
          </span>
        </div>
        {!event.isLast && (
          <div
            className="timeline-line position-absolute"
            style={{ width: "2px", background: "#dee2e6", left: "15px", top: "36px", height: "calc(100% - 24px)" }}
          ></div>
        )}
      </div>

      <div className="timeline-content flex-grow-1">
        <div
          className="card border-0 shadow-sm hover-lift"
          style={{ transition: "all 0.2s ease", borderLeft: "3px solid var(--bs-primary)" }}
        >
          <div className="card-body p-2 px-3">
            {/* Title row */}
            <div className="d-flex justify-content-between align-items-center mb-1">
              <div className="d-flex align-items-center gap-2 flex-grow-1 flex-wrap">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(event._id)}
                  onChange={() => toggleSelection(event._id)}
                  className="form-check-input m-0"
                  style={{ cursor: "pointer" }}
                />
                <span
                  className="badge bg-primary bg-opacity-10 text-primary"
                  style={{ fontSize: "0.7rem", padding: "0.25rem 0.5rem" }}
                >
                  {getModuleName(event.moduleslug)}
                </span>
                <h6
                  className="mb-0 fw-semibold text-truncate"
                  style={{ fontSize: "0.9rem", maxWidth: "300px" }}
                  title={event.payload?.title || event.description || event.action?.replace(/_/g, " ")}
                >
                  {event.payload?.title || event.description || event.action?.replace(/_/g, " ")}
                </h6>
              </div>
              <small className="text-muted d-flex align-items-center gap-1 flex-shrink-0" style={{ fontSize: "0.75rem" }}>
                <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>schedule</span>
                {formatDate(event.createdAt)}
              </small>
            </div>

            {/* Description */}
            {event.payload?.description && (
              <p
                className="text-muted mb-1 small text-truncate"
                style={{ fontSize: "0.8rem", maxWidth: "100%" }}
                title={event.payload.description}
              >
                {event.payload.description}
              </p>
            )}

            {/* Footer row */}
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-1">
              <div className="d-flex align-items-center gap-2 flex-wrap">
                {/* Who did it */}
                {event.createdbydetails && (
                  <div className="d-flex align-items-center gap-1" title={t("Created by")}>
                    <img
                      src={event.createdbydetails.image ? url.SERVER_URL + event.createdbydetails.image : assetImages.defaultUser}
                      alt={event.createdbydetails.fullname}
                      className="rounded-circle border"
                      style={{ width: "20px", height: "20px", objectFit: "cover" }}
                    />
                    <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                      <span className="fw-medium text-dark">
                        {event.createdbydetails.fullname || event.createdbydetails.email}
                      </span>
                    </small>
                  </div>
                )}
                {/* Who it's about */}
                {event.associateduserdetails && (
                  <div className="d-flex align-items-center gap-1" title={t("Associated user")}>
                    <span className="material-symbols-outlined text-secondary" style={{ fontSize: "14px" }}>arrow_forward</span>
                    <img
                      src={event.associateduserdetails.image ? url.SERVER_URL + event.associateduserdetails.image : assetImages.defaultUser}
                      alt={event.associateduserdetails.fullname}
                      className="rounded-circle border"
                      style={{ width: "20px", height: "20px", objectFit: "cover" }}
                    />
                    <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                      <span className="fw-medium text-dark">
                        {event.associateduserdetails.fullname || event.associateduserdetails.email}
                      </span>
                    </small>
                  </div>
                )}
                {event.followers && event.followers.length > 0 && (
                  <small className="text-muted d-flex align-items-center gap-1" style={{ fontSize: "0.75rem" }}>
                    <span className="material-symbols-outlined" style={{ fontSize: "14px" }}>group</span>
                    {event.followers.length}
                  </small>
                )}
              </div>
              <small className="text-muted" style={{ fontSize: "0.7rem" }}>
                {formatDateTimeDMY(event.createdAt)}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Filter Component — filters by moduleslug, labels from API
const TimelineFilter = ({ selectedType, onFilterChange, moduleCounts, getModuleName, t }) => {
  return (
    <div className="filter-container py-3 mb-3">
      <div className="d-flex gap-2 flex-wrap">
        <button
          className={`btn ${selectedType === "all" ? "btn-primary" : "btn-outline-primary"} btn-sm`}
          onClick={() => onFilterChange("all")}
        >
          <span className="material-symbols-outlined" style={{ fontSize: "16px", verticalAlign: "middle", marginRight: "4px" }}>
            select_all
          </span>
          {t("All")}
          <span className="badge bg-white text-primary ms-1 fw-semibold">{moduleCounts.all || 0}</span>
        </button>
        {Object.entries(moduleCounts)
          .filter(([key]) => key !== "all")
          .sort((a, b) => b[1] - a[1])
          .map(([slug, count]) => (
            <button
              key={slug}
              className={`btn ${selectedType === slug ? "btn-primary" : "btn-outline-primary"} btn-sm`}
              onClick={() => onFilterChange(slug)}
            >
              {getModuleName(slug)}
              <span className={`badge ms-1 fw-semibold ${selectedType === slug ? "bg-white text-primary" : "bg-primary bg-opacity-10 text-primary"}`}>
                {count}
              </span>
            </button>
          ))}
      </div>
    </div>
  );
};

// Statistics Card Component
const StatCard = ({ icon, label, value, color = "primary", t }) => {
  return (
    <div className="stat-card mb-3">
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body p-3">
          <div className="d-flex align-items-center gap-3">
            <div
              className={`stat-icon bg-${color} bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center`}
              style={{ width: "50px", height: "50px", minWidth: "50px" }}
            >
              <span className={`material-symbols-outlined text-${color}`} style={{ fontSize: "28px" }}>
                {icon}
              </span>
            </div>
            <div className="flex-grow-1">
              <small className="text-muted d-block mb-1" style={{ fontSize: "0.8rem" }}>{label}</small>
              <h4 className="mb-0 fw-bold">{value}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LeadTimelineBody = () => {
  const params = useParams();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const token = localStorage.getItem("token");

  const { t } = useTranslation();

  const [leadLoading, setLeadLoading] = useState(true);
  const [leadName, setleadName] = useState("");
  const [leadImage, setleadImage] = useState("");
  const [isAuthenticatedUser, setisAuthenticatedUser] = useState(false);

  const [timeLinesData, setTimeLinesData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [isLoading, setIsLoading] = useState(false);
  const [moduleSlugLabels, setModuleSlugLabels] = useState({}); // { "MOD_LEAD": "Lead", ... }

  const [selectedIds, setSelectedIds] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // Resolve slug to label using the map returned by the API
  const getModuleName = (slug) => moduleSlugLabels[slug] || slug || "General";

  const getLeadDetails = async () => {
    try {
      setLeadLoading(true);
      let requestUrl = url.API_BASE_URL + url.API_GET_LEAD_DETAILS + `/${params.id}`;
      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.moderator._id.toString() === userInfo._id.toString()) {
          setisAuthenticatedUser(true);
        }

        const respondedLeadName = response.data.name
          ? `${response.data.name ?? ""} ${response.data.surname ?? ""}`
          : `${response.data.email}`;
        setleadName(respondedLeadName);
        setleadImage(response.data?.photoimage?.path || "");
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLeadLoading(false);
    }
  };

  const getLeadTimeline = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_TIMELINE_EVENTS +
        `?associatedleadid=${params.id}&groupby=flat&limit=100`;

      const response = await getData(requestUrl);

      console.log("response of lead timeline", response);

      // Always store label maps — present even when data is empty
      if (response.moduleslugs) setModuleSlugLabels(response.moduleslugs);

      if (response.status && response.data?.length > 0) {
        const dataWithLastFlag = response.data.map((item, index) => ({
          ...item,
          isLast: index === response.data.length - 1,
        }));
        setTimeLinesData(dataWithLastFlag);
        setFilteredData(dataWithLastFlag);
        setMessageType("success");
        setAlertMessage(response.message || t("Timeline data loaded successfully"));
      } else {
        setTimeLinesData([]);
        setFilteredData([]);
        setMessageType("info");
        setAlertMessage(response.message || t("No timeline data available"));
      }
    } catch (error) {
      console.log(error.message);
      setTimeLinesData([]);
      setFilteredData([]);
      setMessageType("error");
      setAlertMessage(error.message);
    } finally {
      setIsLoading(false);
      setShowAlert(true);
    }
  };

  useEffect(() => {
    if (params.id) {
      const initialData = async () => {
        await getLeadDetails();
        await getLeadTimeline();
        setIsDataReady(true);
      };
      initialData();
    }
  }, [params.id]);

  // Filter by moduleslug
  useEffect(() => {
    if (selectedFilter === "all") {
      setFilteredData(timeLinesData);
    } else {
      setFilteredData(
        timeLinesData.filter((item) => (item.moduleslug || "general") === selectedFilter)
      );
    }
  }, [selectedFilter, timeLinesData]);

  // Count records per moduleslug
  const getModuleCounts = () => {
    const counts = { all: timeLinesData.length };
    timeLinesData.forEach((item) => {
      const key = item.moduleslug || "general";
      counts[key] = (counts[key] || 0) + 1;
    });
    return counts;
  };

  // Group filtered events by moduleslug for the "all" grouped display
  const getGroupedByModule = () => {
    return filteredData.reduce((acc, event) => {
      const key = event.moduleslug || "general";
      if (!acc[key]) acc[key] = [];
      acc[key].push(event);
      return acc;
    }, {});
  };

  const getLatestActivityTime = () => {
    if (timeLinesData.length === 0) return t("No activity");
    const date = new Date(timeLinesData[0].createdAt);
    const now = new Date();
    const diffInHours = Math.floor((now - date) / (1000 * 60 * 60));
    if (diffInHours < 1) return t("Just now");
    if (diffInHours < 24) return `${diffInHours} ${t("hours ago")}`;
    return date.toLocaleDateString();
  };

  const toggleSelection = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedIds.length === filteredData.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(filteredData.map((item) => item._id));
    }
  };

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LEAD"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-contact-timeline-wrapper bg-white">
          <CrmLeadInformationCommonHeader
            moduleName="timeline"
            leadName={leadName}
            leadImage={leadImage}
            isAuthenticatedUser={isAuthenticatedUser}
            leadLoading={leadLoading}
          />
          <div className="crm-info-container">
            <div className="container-fluid px-lg-5 mt-3">
              {/* Lead header */}
              {leadLoading || !isDataReady ? (
                <div className="patient-header shadow-sm border border-2 border-primary rounded-3 bg-white">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <span className="placeholder-glow">
                      <span className="placeholder rounded-circle border border-3 border-primary shadow me-2" style={{ width: 80, height: 80, display: "inline-block" }}></span>
                    </span>
                    <div className="flex-grow-1">
                      <h4 className="mb-1 fw-bold text-dark d-flex align-items-center gap-2 placeholder-glow">
                        <span className="placeholder col-6"></span>
                      </h4>
                      <p className="mb-0 text-muted d-flex align-items-center gap-2 placeholder-glow">
                        <span className="placeholder col-4"></span>
                      </p>
                      <p className="mb-0 mt-1 text-muted small d-flex align-items-center gap-2 placeholder-glow">
                        <span className="placeholder col-3"></span>
                      </p>
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <span className="placeholder-glow">
                        <span className="placeholder btn btn-primary" style={{ minWidth: 120, height: 38 }}></span>
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="patient-header shadow-sm border border-2 border-primary rounded-3 bg-white">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <div className="position-relative">
                      <img
                        className="rounded-circle border border-3 border-primary shadow"
                        height={80}
                        width={80}
                        src={leadImage === "" || !leadImage ? assetImages.defaultUser : url.SERVER_URL + leadImage}
                        alt="Lead"
                      />
                      <div className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white" style={{ width: "20px", height: "20px" }} title={t("Active")}></div>
                    </div>
                    <div className="flex-grow-1">
                      <h4 className="mb-1 fw-bold text-dark">{leadName || t("Lead Name")}</h4>
                      <p className="mb-0 text-muted d-flex align-items-center gap-2">
                        <span className="material-symbols-outlined text-primary" style={{ fontSize: "18px" }}>timeline</span>
                        {t("Timeline & Activity History")}
                      </p>
                      {timeLinesData.length > 0 && (
                        <p className="mb-0 mt-1 text-muted small d-flex align-items-center gap-2">
                          <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>event_note</span>
                          {timeLinesData.length} {t("total events")} • {t("Last activity")}: {getLatestActivityTime()}
                        </p>
                      )}
                    </div>
                    <div className="d-flex gap-2 align-items-center ms-2">
                      <button
                        className="btn btn-primary d-flex align-items-center gap-2 shadow-sm"
                        onClick={getLeadTimeline}
                        disabled={isLoading}
                        title={t("Reload Timeline")}
                        style={{ minWidth: 120 }}
                      >
                        <span className="material-symbols-outlined" style={{ fontSize: "20px" }}>
                          {isLoading ? "hourglass_empty" : "refresh"}
                        </span>
                        <span className="d-none d-md-inline">{isLoading ? t("Loading...") : t("Refresh")}</span>
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <div className="row mt-2">
                <div className="col-lg-8 mb-4 mb-lg-0">
                  <div className="bg-white rounded-3 shadow-sm p-4">
                    {/* Header */}
                    {leadLoading || !isDataReady ? (
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0 fw-bold d-flex align-items-center gap-2 placeholder-glow">
                          <span className="placeholder rounded-circle bg-primary bg-opacity-25" style={{ width: 32, height: 32 }}></span>
                          <span className="placeholder col-3" style={{ height: 16, width: 150 }}></span>
                        </h5>
                        <div className="d-flex align-items-center gap-2">
                          <span className="placeholder-glow"><span className="placeholder btn btn-outline-primary" style={{ minWidth: 100, height: 32 }}></span></span>
                          <span className="placeholder-glow"><span className="placeholder btn btn-outline-primary" style={{ minWidth: 80, height: 32 }}></span></span>
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                          <span className="material-symbols-outlined text-primary">history</span>
                          {t("Timeline Events")}
                        </h5>
                        <div className="d-flex align-items-center gap-2">
                          {filteredData.length > 0 && (
                            <button className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2" onClick={handleSelectAll}>
                              <span className="material-symbols-outlined" style={{ fontSize: "18px" }}>
                                {selectedIds.length === filteredData.length ? "deselect" : "select_all"}
                              </span>
                              {selectedIds.length === filteredData.length ? t("Deselect All") : t("Select All")}
                            </button>
                          )}
                          <button className="btn btn-outline-primary bg-primary bg-opacity-10 text-primary" style={{ cursor: "default" }}>
                            {filteredData.length} {t("events")}
                          </button>
                        </div>
                      </div>
                    )}

                    {/* Module filter buttons */}
                    {leadLoading || !isDataReady ? (
                      <div className="filter-container py-3 mb-3">
                        <div className="d-flex gap-2 flex-wrap">
                          {[...Array(4)].map((_, idx) => (
                            <span className="placeholder-glow" key={idx}>
                              <span className="placeholder btn btn-outline-primary" style={{ minWidth: 90, height: 32 }}></span>
                            </span>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <TimelineFilter
                        selectedType={selectedFilter}
                        onFilterChange={setSelectedFilter}
                        moduleCounts={getModuleCounts()}
                        getModuleName={getModuleName}
                        t={t}
                      />
                    )}

                    {/* Timeline list */}
                    {isLoading ? (
                      <div className="text-center py-5">
                        <div className="loading-spinner mx-auto mb-3"></div>
                        <p className="text-muted">{t("Loading timeline data...")}</p>
                      </div>
                    ) : filteredData.length > 0 ? (
                      <div className="timeline-container">
                        {selectedFilter === "all" ? (
                          // Grouped by module
                          Object.entries(getGroupedByModule())
                            .sort((a, b) => b[1].length - a[1].length)
                            .map(([slug, events]) => (
                              <div key={slug} className="mb-4">
                                <div className="d-flex align-items-center gap-2 mb-2 pb-1 border-bottom">
                                  <span className="material-symbols-outlined text-primary" style={{ fontSize: "18px" }}>folder</span>
                                  <span className="fw-semibold text-dark" style={{ fontSize: "0.9rem" }}>{getModuleName(slug)}</span>
                                  <span className="badge bg-primary bg-opacity-10 text-primary ms-1" style={{ fontSize: "0.72rem" }}>{events.length}</span>
                                </div>
                                {events.map((event, index) => (
                                  <TimelineItem
                                    key={event._id}
                                    event={event}
                                    t={t}
                                    index={index}
                                    selectedIds={selectedIds}
                                    toggleSelection={toggleSelection}
                                    getModuleName={getModuleName}
                                  />
                                ))}
                              </div>
                            ))
                        ) : (
                          // Flat list for a specific module
                          filteredData.map((event, index) => (
                            <TimelineItem
                              key={event._id}
                              event={event}
                              t={t}
                              index={index}
                              selectedIds={selectedIds}
                              toggleSelection={toggleSelection}
                              getModuleName={getModuleName}
                            />
                          ))
                        )}
                      </div>
                    ) : isDataReady ? (
                      <div className="empty-state">
                        <span className="material-symbols-outlined empty-state-icon">event_busy</span>
                        <h5 className="text-muted mb-2">{t("No timeline events found")}</h5>
                        <p className="text-muted">
                          {selectedFilter === "all"
                            ? t("There are no events to display for this lead.")
                            : t("No events found for the selected filter. Try a different filter.")}
                        </p>
                      </div>
                    ) : null}
                  </div>
                </div>

                {/* Sidebar stats */}
                <div className="col-lg-4">
                  <div className="sticky-top" style={{ top: "20px" }}>
                    <h5 className="mb-3 fw-bold d-flex align-items-center gap-2">
                      <span className="material-symbols-outlined text-primary">analytics</span>
                      {t("Activity Summary")}
                    </h5>

                    {leadLoading || !isDataReady ? (
                      <>
                        {[...Array(3)].map((_, idx) => (
                          <div className="card border-0 shadow-sm mb-3 placeholder-glow" key={idx}>
                            <div className="card-body d-flex align-items-center gap-3">
                              <span className="placeholder rounded-circle bg-primary bg-opacity-25" style={{ width: 32, height: 32 }}></span>
                              <div className="flex-grow-1">
                                <p className="placeholder col-4 mb-2 placeholder-glow" style={{ height: 10 }}></p>
                              </div>
                            </div>
                          </div>
                        ))}
                        <div className="card border-0 shadow-sm mt-3 placeholder-glow">
                          <div className="card-body">
                            <span className="placeholder col-6 mb-3" style={{ height: 18 }}></span>
                            {[...Array(3)].map((_, idx) => (
                              <div key={idx} className="mb-2">
                                <div className="d-flex justify-content-between align-items-center mb-1">
                                  <span className="placeholder col-3"></span>
                                  <span className="placeholder col-1"></span>
                                </div>
                                <div className="progress" style={{ height: "6px" }}>
                                  <div className="progress-bar bg-primary placeholder" style={{ width: "100%" }}></div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <StatCard icon="event_note" label={t("Total Events")} value={timeLinesData.length} color="primary" t={t} />
                        <StatCard icon="schedule" label={t("Last Activity")} value={getLatestActivityTime()} color="success" t={t} />
                        <StatCard
                          icon="category"
                          label={t("Active Modules")}
                          value={Object.keys(getModuleCounts()).filter((k) => k !== "all").length}
                          color="info"
                          t={t}
                        />

                        {timeLinesData.length > 0 && (
                          <div className="card border-0 shadow-sm mt-3">
                            <div className="card-body">
                              <h6 className="fw-semibold mb-3 d-flex align-items-center gap-2">
                                <span className="material-symbols-outlined text-warning">bar_chart</span>
                                {t("Module Distribution")}
                              </h6>
                              {Object.entries(getModuleCounts())
                                .filter(([key]) => key !== "all")
                                .sort((a, b) => b[1] - a[1])
                                .map(([slug, count]) => (
                                  <div key={slug} className="mb-2">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                      <small className="text-muted">{getModuleName(slug)}</small>
                                      <small className="fw-semibold">{count}</small>
                                    </div>
                                    <div className="progress" style={{ height: "6px" }}>
                                      <div
                                        className="progress-bar bg-primary"
                                        role="progressbar"
                                        style={{ width: `${(count / timeLinesData.length) * 100}%` }}
                                      ></div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>

        <style>
          {`
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(20px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .hover-lift { transition: all 0.2s ease; }
            .hover-lift:hover { transform: translateY(-1px); box-shadow: 0 0.25rem 0.75rem rgba(0,0,0,0.1) !important; }
            .timeline-icon { position: relative; z-index: 2; }
            .timeline-icon-wrapper:hover .timeline-icon { transform: scale(1.05); }
            .timeline-container { max-height: calc(100vh - 300px); overflow-y: auto; padding-right: 8px; }
            .timeline-container::-webkit-scrollbar { width: 6px; }
            .timeline-container::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
            .timeline-container::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }
            .timeline-container::-webkit-scrollbar-thumb:hover { background: #555; }
            .stat-card { animation: fadeInUp 0.3s ease-out both; }
            .stat-card:nth-child(1) { animation-delay: 0.05s; }
            .stat-card:nth-child(2) { animation-delay: 0.1s; }
            .stat-card:nth-child(3) { animation-delay: 0.15s; }
            .patient-header { padding: 1.5rem 2rem; margin-bottom: 2rem; transition: all 0.3s ease; background: linear-gradient(135deg, rgba(var(--bs-primary-rgb), 0.02) 0%, rgba(var(--bs-primary-rgb), 0.05) 100%); }
            .patient-header:hover { box-shadow: 0 0.5rem 1.5rem rgba(var(--bs-primary-rgb), 0.15) !important; }
            .patient-header h4 { font-size: 1.5rem; letter-spacing: -0.5px; }
            .patient-header .btn { font-weight: 500; padding: 0.625rem 1.25rem; border-radius: 8px; transition: all 0.3s ease; }
            .patient-header .btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(var(--bs-primary-rgb), 0.25) !important; }
            .patient-header .btn:disabled { opacity: 0.6; cursor: not-allowed; }
            .patient-header img { object-fit: cover; transition: all 0.3s ease; }
            .patient-header img:hover { transform: scale(1.05); }
            @media (max-width: 768px) {
              .patient-header { padding: 1rem; }
              .patient-header h4 { font-size: 1.25rem; }
              .patient-header .btn { padding: 0.5rem 1rem; }
            }
            .filter-container .btn-sm { padding: 0.5rem 1rem; font-size: 0.875rem; border-radius: 20px; transition: all 0.3s ease; }
            .loading-spinner { display: inline-block; width: 40px; height: 40px; border: 4px solid rgba(0,0,0,0.1); border-radius: 50%; border-top-color: #667eea; animation: spin 1s ease-in-out infinite; }
            @keyframes spin { to { transform: rotate(360deg); } }
            .empty-state { text-align: center; padding: 4rem 2rem; }
            .empty-state-icon { font-size: 80px; color: #dee2e6; margin-bottom: 1rem; }
          `}
        </style>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default LeadTimelineBody;
